import React from "react"
import ContentLoader from "react-content-loader" 

const AvatarLoader = () => (
 
  <ContentLoader 
    speed={2}
    width={50}
    height={50}
    viewBox="0 0 50 50"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <circle cx="25" cy="27" r="23" />
  </ContentLoader>
)

export default AvatarLoader